import all from './all.js'
const documentType = ['Bill of Lading', 'Proof of Delivery', 'Trip Sheet', 'Cat Scale', 'Fuel Receipt', 'Other Document']
const state = {
  namespaced: true,
  state: {
    documentType: documentType
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    all
  },
  getters: {
  }
}

export default state